import React from 'react';
import styles from './Label.module.scss';

const Label = ({ text, required, right }) => {
  return (
    <label className={styles.label} style={{ textAlign: right ? 'end' : '' }}>
      {text} {required && <span className={styles.required}>*</span>}
    </label>
  );
};

export default Label;
